import Navbar from "../components/navbar";
import Hero from "../components/Hero";
import Footer from "../components/Footer";
import AboutUs from "../components/AboutUs";

import AboutImg from "../assets/night.jpg";
function About() {
  return (
    <>
      <Navbar />
      <Hero 
      cName="hero-mid" 
      heroImg={AboutImg} 
      title="About" 
      btnClass="hide" />
      <AboutUs/>
        <Footer/>
    </>
    
  );
}

export default About;
